import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import ResourceForm from '../containers/ResourceFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class ResourceAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `ResourceAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('resources_route_add')} />
          <ResourceForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default ResourceAddScreen;

Logger.log('silly', `ResourceAddScreen loaded.`);
